import './CreateSubFlowModal.scss';
import { SubflowModalAction } from '../../services/SubflowService';
class CreateSubFlowModalController {
    static $inject = ['close', 'body', 'confirm', 'size', 'modalClass', 'modalSizeClass', 'bodyClass', 'bodyContentClass', 'footerClass', 'footerContentClass', 'action', 'shortName', 'APPLICATION_DEFAULT_IMAGE', 'whatIsSubflow', 'BlipToastService', 'LoadingService', 'SubflowService', 'ApplicationService2', 'SharedToastsService', '$translate', 'MEDIA_PROFILE_FOR_AVATARS'];
    constructor(close, body, confirm, size, modalClass, modalSizeClass, bodyClass, bodyContentClass, footerClass, footerContentClass, action, shortName, APPLICATION_DEFAULT_IMAGE, whatIsSubflow, BlipToastService, LoadingService, SubflowService, ApplicationService2, SharedToastsService, $translate, MEDIA_PROFILE_FOR_AVATARS) {
        'ngInject';
        this.close = close;
        this.body = body;
        this.confirm = confirm;
        this.size = size;
        this.modalClass = modalClass;
        this.modalSizeClass = modalSizeClass;
        this.bodyClass = bodyClass;
        this.bodyContentClass = bodyContentClass;
        this.footerClass = footerClass;
        this.footerContentClass = footerContentClass;
        this.action = action;
        this.shortName = shortName;
        this.APPLICATION_DEFAULT_IMAGE = APPLICATION_DEFAULT_IMAGE;
        this.whatIsSubflow = whatIsSubflow;
        this.BlipToastService = BlipToastService;
        this.LoadingService = LoadingService;
        this.SubflowService = SubflowService;
        this.ApplicationService2 = ApplicationService2;
        this.SharedToastsService = SharedToastsService;
        this.$translate = $translate;
        this.MEDIA_PROFILE_FOR_AVATARS = MEDIA_PROFILE_FOR_AVATARS;
        this.submitButtonEnabled = false;
        this.formattedTags = [];
        this.maxTagsExceeded = false;
        this.formContent = {
            name: '',
            description: '',
            tags: '',
            image: '',
            tenantId: '',
            userIdentity: '',
            isShared: false,
        };
        this.onInputChange = (event) => {
            if (event.detail.name === 'tags') {
                this.formContent.tags = (event.detail.data.length > 0 ? event.detail.data.join() : '');
                this.updateFormattedTags();
                this.maxTagsExceeded = event.detail.data.length > 10;
                this.updateSubmitButtonEnabled();
            }
            else {
                this.formContent[event.detail.name] = event.detail.value;
                if (event.detail.name === 'name') {
                    this.updateSubmitButtonEnabled();
                }
            }
        };
        this._close = this.close;
    }
    async $onInit() {
        if (this.action === SubflowModalAction.Update) {
            await this.loadSubflow();
        }
        this.addEvents();
    }
    async loadSubflow() {
        let errorOnLoading = false;
        try {
            const subflow = await this.SubflowService.get(this.shortName);
            if (subflow) {
                this.formContent.name = subflow.configuration.name;
                this.formContent.description = subflow.configuration.description;
                this.formContent.tags = this.fixTagFormat(subflow.configuration.tags);
                this.updateFormattedTags();
                this.formContent.image = subflow.configuration.image;
            }
            else {
                errorOnLoading = true;
            }
        }
        catch (ex) {
            errorOnLoading = true;
        }
        if (errorOnLoading) {
            this.BlipToastService.show('danger', {
                title: await this.$translate('builder.subflow.errorMsg.title'),
                msg: await this.$translate('builder.subflow.errorMsg.errorOnLoading'),
            });
        }
    }
    async validateSubflowName() {
        const name = await this.formContent.name.trim();
        const letterFirstPosition = /(^[a-zA-Z])/;
        if (name === '') {
            return false;
        }
        if (!letterFirstPosition.exec(name)) {
            this.BlipToastService.show('danger', {
                title: await this.$translate('builder.subflow.errorMsg.title'),
                msg: await this.$translate('builder.subflow.errorMsg.invalidName'),
            });
            return false;
        }
        return true;
    }
    async validateForm() {
        return await this.validateSubflowName();
    }
    async _confirm() {
        const formaValidated = await this.validateForm();
        if (!formaValidated) {
            return;
        }
        else {
            this.confirm(this.formContent);
        }
        this._close(true);
    }
    async cancel() {
        this._close(false);
    }
    getUploadElement() {
        return document.querySelector('#subflow-modal bds-upload').shadowRoot.querySelector('.upload__input');
    }
    fixTagFormat(tags) {
        const listTags = tags ? tags.split(',') : [];
        if (listTags.length > 2) {
            listTags.shift();
            listTags.pop();
        }
        return listTags.join();
    }
    updateFormattedTags() {
        this.formattedTags = this.formContent.tags ? this.formContent.tags.split(',') : [];
    }
    updateSubmitButtonEnabled() {
        this.submitButtonEnabled =
            (this.formContent.name && this.formContent.name.trim() !== '' && this.formContent.name.length > 2)
                && (!this.maxTagsExceeded);
    }
    validateFileType(filename) {
        return ['gif', 'png', 'jpeg', 'jpg'].includes(`${filename.split('.').pop()}`);
    }
    addEvents() {
        const subflowModal = document.querySelector('#subflow-modal');
        subflowModal.addEventListener('bdsModalChanged', e => { subflowModal.remove(); });
        document.getElementById('create-subflow-modal-name')
            .addEventListener('bdsChange', (e) => { e.detail.name = 'name'; this.onInputChange(e); });
        document.getElementById('create-subflow-modal-description')
            .addEventListener('bdsChange', (e) => { e.detail.name = 'description'; this.onInputChange(e); });
        document.getElementById('create-subflow-modal-tags')
            .addEventListener('bdsChangeChips', (e) => { e.detail.name = 'tags'; this.onInputChange(e); });
        document.querySelector('#subflow-modal bds-upload')
            .addEventListener('bdsUploadChange', (e) => this.fileUploaded(e.detail.value[0]));
    }
    async fileUploaded(file) {
        try {
            if (!file || !this.validateFileType(file.name)) {
                throw 'error';
            }
            this.LoadingService.startLoading();
            this.formContent.image = await this.ApplicationService2.uploadFile(file, { profile: this.MEDIA_PROFILE_FOR_AVATARS });
        }
        catch (err) {
            console.error(err);
            this.SharedToastsService.showUploadErrorToast(err.status);
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
}
CreateSubFlowModalController.$inject = ['close', 'body', 'confirm', 'size', 'modalClass', 'modalSizeClass', 'bodyClass', 'bodyContentClass', 'footerClass', 'footerContentClass', 'action', 'shortName', 'APPLICATION_DEFAULT_IMAGE', 'whatIsSubflow', 'BlipToastService', 'LoadingService', 'SubflowService', 'ApplicationService2', 'SharedToastsService', '$translate', 'MEDIA_PROFILE_FOR_AVATARS'];
export default CreateSubFlowModalController;
